import { cn } from '@/lib/utils';

// SVG rather than border-dashed: CSS leaves dash length to the browser.
export const DownloadedRing = ({
  className
}: {
  className?: string;
}) => <svg aria-hidden="true" className={cn('shrink-0', className)} fill="none" viewBox="0 0 39 39" xmlns="http://www.w3.org/2000/svg" data-sentry-element="svg" data-sentry-component="DownloadedRing" data-sentry-source-file="downloaded-ring.tsx">
    <circle cx="19.5" cy="19.5" r="18.665" stroke="currentColor" strokeDasharray="2.932 2.932" strokeWidth="1.33" data-sentry-element="circle" data-sentry-source-file="downloaded-ring.tsx" />
  </svg>;